<div class="card mv-list">
    <div class="card-body">
        <form [formGroup]="form">
            <!-- Toolbar -->
            <div class="mv-list__toolbar">
                <div class="mv-list__toolbar-end">
                    <div class="mv-search">
                        <i class="far fa-magnifying-glass"></i>
                        <input type="text" class="form-control fs-7" name="search" placeholder="{{'SEARCH' | translate}}" formControlName="search"/>
                    </div>

                    <button type="button" class="btn mv-filter-btn" [class.active]="filterOverlayIsOpen" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="filterOverlayIsOpen = !filterOverlayIsOpen">
                        <i class="far fa-sliders"></i>
                        {{'FILTER' | translate}}
                        <span *ngIf="activeFilterCount > 0" class="mv-filter-btn__count">{{ activeFilterCount }}</span>
                    </button>
                    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="filterOverlayIsOpen = !filterOverlayIsOpen" [cdkConnectedOverlayBackdropClass]="'opacity-0'" [cdkConnectedOverlayOpen]="filterOverlayIsOpen" [cdkConnectedOverlayPositions]="[connectedOverlayPositions]">
                        <div class="mv-filter-menu">
                            <div class="mv-filter-menu__field">
                                <div class="mv-filter-menu__label">{{'IS_CONTRACT_ACCESS_REQUEST_VALID' | translate}}</div>
                                <is-multi-select [prependIcon]="false" [showInitials]="false" [solidInput]="false" [options]="yesNoOptions" formControlName="valid" [emitChangeOnClose]="true" [menuHasSameWidthAsInput]="true"></is-multi-select>
                            </div>
                            <div class="mv-filter-menu__field">
                                <div class="mv-filter-menu__label">{{'PERMISSION_GRANTED' | translate}}</div>
                                <is-multi-select [prependIcon]="false" [showInitials]="false" [solidInput]="false" [options]="yesNoOptions" formControlName="permissionGranted" [emitChangeOnClose]="true" [menuHasSameWidthAsInput]="true"></is-multi-select>
                            </div>
                        </div>
                    </ng-template>

                    <button type="button" class="btn btn-primary" (click)="onContractAccessRequest()">
                        <i class="far fa-plus"></i>
                        {{ 'REQUEST_ACCESS_TO_NEW_CONTRACT' | translate }}
                    </button>
                </div>
            </div>

            <!-- Table -->
            <div class="mv-table-wrap">
                <table class="mv-table">
                    <thead>
                        <tr>
                            <th class="mv-sortable" (click)="sortBy('contactEmail')">
                                {{ 'CONTACT_EMAIL' | translate }}
                                <i class="fas" [ngClass]="getSortIconClass('contactEmail')"></i>
                            </th>
                            <th class="mv-sortable" (click)="sortBy('contactNumber')">
                                {{ 'CONTACT_NUMBER' | translate }}
                                <i class="fas" [ngClass]="getSortIconClass('contactNumber')"></i>
                            </th>
                            <th class="mv-sortable" (click)="sortBy('entityTIN')">
                                {{ 'ENTITY_TIN' | translate }}
                                <i class="fas" [ngClass]="getSortIconClass('entityTIN')"></i>
                            </th>
                            <th class="mv-sortable" (click)="sortBy('creationDate')">
                                {{ 'CREATION_DATE' | translate }}
                                <i class="fas" [ngClass]="getSortIconClass('creationDate')"></i>
                            </th>
                            <th class="mv-sortable" (click)="sortBy('isContractAccessRequestValid')">
                                {{ 'IS_CONTRACT_ACCESS_REQUEST_VALID' | translate }}
                                <i class="fas" [ngClass]="getSortIconClass('isContractAccessRequestValid')"></i>
                            </th>
                            <th class="mv-sortable" (click)="sortBy('permissionGranted')">
                                {{ 'PERMISSION_GRANTED' | translate }}
                                <i class="fas" [ngClass]="getSortIconClass('permissionGranted')"></i>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngIf="!isLoading && hasError">
                            <td colspan="6" class="mv-empty">
                                <i class="far fa-triangle-exclamation"></i>
                                {{ 'ERROR_LOADING_CONTRACT_ACCESS_REQUESTS' | translate }}
                                <div class="mt-3">
                                    <button type="button" class="btn btn-light btn-sm" (click)="fetchAccessRequests()">
                                        <i class="far fa-rotate-right"></i>
                                        {{ 'TRY_AGAIN' | translate }}
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr *ngIf="!isLoading && !hasError && visibleRequests.length == 0">
                            <td colspan="6" class="mv-empty">
                                <i class="far fa-key"></i>
                                {{ (accessRequests.length == 0 ? 'NO_CONTRACT_ACCESS_REQUESTS' : 'NO_DATA_FOUND') | translate }}
                            </td>
                        </tr>

                        <tr class="mv-row" *ngFor="let request of requestsPage">
                            <td class="fw-semibold">{{ request.contactEmail | empty: '-' }}</td>
                            <td class="mv-num">{{ request.contactNumber | empty: '-' }}</td>
                            <td class="mv-num">{{ request.entityTIN | empty: '-' }}</td>
                            <td class="mv-num text-gray-600">{{ request.creationDate | date:'dd/MM/yyyy - HH:mm' }}</td>
                            <td>
                                <span class="mv-status" [ngClass]="request.isContractAccessRequestValid ? 'mv-status--success' : 'mv-status--danger'">
                                    {{ (request.isContractAccessRequestValid ? 'YES' : 'NO') | translate }}
                                </span>
                            </td>
                            <td>
                                <span class="mv-status" [ngClass]="request.permissionGranted ? 'mv-status--success' : 'mv-status--warning'">
                                    {{ (request.permissionGranted ? 'YES' : 'NO') | translate }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Pagination -->
            <div class="mv-list__footer">
                <div class="mv-page-size">
                    {{ 'ROWS_PER_PAGE' | translate }}
                    <mat-select formControlName="pageSize" hideSingleSelectionIndicator="true">
                        <mat-option [value]="size" *ngFor="let size of paginationPageSizes">{{size}}</mat-option>
                    </mat-select>
                </div>

                <div class="mv-pager">
                    <span class="mv-pager__range">{{ 'RECORDS_RANGE' | translate: requestsRange }}</span>
                    <button type="button" class="mv-pager__btn" [disabled]="currentPage == 1" (click)="previousPage()">
                        <i class="far fa-chevron-left"></i>
                    </button>
                    <span class="mv-pager__current">{{ currentPage }}</span>
                    <button type="button" class="mv-pager__btn" [disabled]="currentPage >= maxPage" (click)="nextPage()">
                        <i class="far fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
